import { AssignUsersEventPayload, UsersAssignerDialogViewModel } from '@Alternatives/Assignments/Components/UsersAssignerDialog';
import UsersAssignerDialog from '@Alternatives/Assignments/Components/UsersAssignerDialog.vue';
import { BulkAssignUsersCommandV1, UnassignUserCommandV1 } from '@Alternatives/Assignments/Domain/commands-core';
import AssignmentsCommands from '@Alternatives/Assignments/Domain/commands-vue-component';
import AssignmentsQueries from '@Alternatives/Assignments/Domain/queries-vue-component';
import { AlternativeReadModel, ManageAssignmentsPageReadModel, UserReadModel } from '@Alternatives/Assignments/Domain/readmodels';
import PortfolioOrDecisionNavigation from '@common/Components/PortfolioOrDecisionNavigation.vue';
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        PortfolioOrDecisionNavigation, UsersAssignerDialog
    }
})
export default class ManageAssignmentsPage extends mixins(AssignmentsQueries, AssignmentsCommands)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId() { return Number.parseInt(this.$route.params.tchProjectId); }

    rm: ManageAssignmentsPageReadModel | null = null;
    searchPhrase: string | null = null;
    filterByListId: string | null = null;
    filterByUserId: number | null = null;

    usersAssignerDialog: UsersAssignerDialogViewModel = new UsersAssignerDialogViewModel();

    get noneSelected(): boolean { return !this.rm.Alternatives.some(a => a.IsUiSelected); }
    get allSelected(): boolean { return !this.rm.Alternatives.some(a => !a.IsUiSelected); }
    get anySelected(): boolean { return this.rm.Alternatives.some(a => a.IsUiSelected); }
    get selected(): AlternativeReadModel[] { return this.rm.Alternatives.filter(a => a.IsUiSelected) || [] }
    get alternativesView(): AlternativeReadModel[]
    {
        let view = new Array(...this.rm.Alternatives);

        if (this.searchPhrase)
        {
            const phrase = this.searchPhrase.toLowerCase();
            view = view.filter(a => a.Name.toLowerCase().indexOf(phrase) > -1);
        }

        if (this.filterByUserId)
        {
            if (this.filterByUserId === -1)
            {
                view = view.filter(a => a.UserIds.length === 0);
            }
            else
            {
                view = view.filter(a => a.UserIds.includes(this.filterByUserId));
            }
        }

        //if (this.acceptanceFilter)
        //{
        //    return view.filter(a => a.Acceptance === this.acceptanceFilter);
        //}

        //if (this.kanbanFilter)
        //{
        //    return view.filter(a => a.KanbanStatus === this.kanbanFilter);
        //}

        return view;
    }
    get users(): UserReadModel[] { return this.rm.Users; }

    showBulkUsersAssignerDialog()
    {
        const selectedIds = this.selected.map(a => a.Id);
        this.usersAssignerDialog.dialogTitle = `Bulk assign ${selectedIds.length} ${this.rm.AlternativesLabel}`;
        this.usersAssignerDialog.show(selectedIds, this.rm.Users, this.rm.ProjectUserTags);
    }

    showUsersAssignerDialog(rm: AlternativeReadModel)
    {
        this.usersAssignerDialog.dialogTitle = `Assign ${rm.Name}`;
        this.usersAssignerDialog.show([rm.Id], this.rm.Users, this.rm.ProjectUserTags);
    }
   

    setFilterByList(listId: string | null)
    {
        this.rm.Alternatives = [];
        this.filterByListId = listId;
        this.runManageAssignmentsPageQueryV1(this.workspaceId, this.tchProjectId, this.filterByListId);
    }

    setFilterByUser(userId: number | null)
    {
        this.filterByUserId = userId;
    }


    getUserName(userId: number): string | null
    {
        return this.rm.Users.find(u => u.Id === userId)?.Name;
    }

    selectAll()
    {
        this.alternativesView.forEach(a => a.IsUiSelected = true);
    }

    unselectAll()
    {
        this.rm.Alternatives.forEach(a => a.IsUiSelected = false);
    }

    handleUnassignUserCommand(alternative: AlternativeReadModel, userId: number)
    {
        this.invokeUnassignUserCommandV1(this.workspaceId, this.tchProjectId, alternative.Id, userId);
    }

    handleBulkAssignUsersCommand(e: AssignUsersEventPayload)
    {
        this.invokeBulkAssignUsersCommandV1(this.workspaceId, this.tchProjectId, e.AlternativeIds, e.UserIds);
    }

    mounted()
    {
        document.title = "Manage contributors | TransparentChoice";
        this.runManageAssignmentsPageQueryV1(this.workspaceId, this.tchProjectId, this.filterByListId);
    }

    onSetModel(model: any, modelName: string): void 
    {
        if (modelName === "ManageAssignmentsPageReadModel")
        {
            this.rm = model as ManageAssignmentsPageReadModel;
            this.usersAssignerDialog.close();
        }
    }

    onCommandSucceed(cmd: any, correlationId: string)
    {
        if (BulkAssignUsersCommandV1.matchType(cmd))
        {
            this.rm.Alternatives = [];
            this.runManageAssignmentsPageQueryV1(this.workspaceId, this.tchProjectId, this.filterByListId);
        }
        else if (UnassignUserCommandV1.matchType(cmd))
        {
            this.rm.Alternatives = [];
            this.runManageAssignmentsPageQueryV1(this.workspaceId, this.tchProjectId, this.filterByListId);
        }
    }
}
